module.exports = __webpack_public_path__ + "static/media/inventory.f884542b.svg";